// extracted by mini-css-extract-plugin
export default {"modalVisibleContainer":"modalStyles_modalVisibleContainer__VUg7x","closeButton":"modalStyles_closeButton__ycsrm","slideInFromRight":"modalStyles_slideInFromRight__DkXTN"};